import React from 'react';
import { useInfoModal } from '../../../../hooks';
import styles from './styles.css';
import { useTranslation } from 'react-i18next';

export default function DataTablePanel({ highlights, trends, checkboxes, groupHighlights }) {
	const { t } = useTranslation();
	const infoOnClick = useInfoModal();
	return (
		<div className="idp-footer__middle advanced-settings">
			<div className="uk-width-1-2@s">
				{highlights.options.length ? (
					<>
						<span>{highlights.header}</span>
						<br />
						<div className="idp-footer__highlight-inner ">
							{highlights.options.map((option, index) => (
								<label
									key={`${option.text.split(' ').join('')}_${index}`}
									className={`reduced-size-label clickable_pointer  ${option.class}`}
								>
									<input checked={option.checked} type="checkbox" onChange={(e) => option.onclick(e)} />
									{option.text}

									{option.info ? (
										<img
											src="/dist/src/img/icons/infoSymbol.png"
											onClick={infoOnClick(option.info)}
											className={`clickable_pointer ${styles.infoIcon}`}
										/>
									) : null}
								</label>
							))}
						</div>
					</>
				) : null}
				{groupHighlights && groupHighlights.options.length ? (
					<div className={`${styles.groupHighlightSelectContainer} ${styles.groupHighlightSelectContainerData}`}>
						<span>{groupHighlights.header}:</span>

						<select
							className={styles.groupHighlightSelect}
							onChange={(e) => {
								groupHighlights.selected = e.target.value;
								groupHighlights.onChange(e);
							}}
							value={groupHighlights.selected}
						>
							<option value="">{t('Select group to highlight')}</option>
							{groupHighlights.options.map((option, index) => (
								<option key={index} value={option.value}>
									{option.text}
								</option>
							))}
						</select>
					</div>
				) : null}
			</div>

			<div className="uk-width-1-2@s">
				{trends ? (
					<div className={styles.trendOptions}>
						{trends.options.map((option, index) => (
							<div className={styles.trendOption} key={index}>
								<label onClick={() => option.onClick()} key={`${option.text.split(' ').join('')}_${index}`}>
									<input
										type="radio"
										className="idp-footer__button"
										name={`footer_radio_${index}_advanced`}
										checked={option.checked}
										onChange={(e) => {}}
									/>
									{option.text}
								</label>

								{option.checked && option.id && option.id === 'significantChanges' ? (
									<div>
										<select
											className={styles.dropdown}
											value={option.dropdown.selected}
											onChange={(e) => option.dropdown.onChange(e.target.value)}
										>
											{option.dropdown.options.map((opt) => (
												<option key={opt} value={opt}>{`${opt}%`}</option>
											))}
										</select>
									</div>
								) : null}
							</div>
						))}
					</div>
				) : null}
				{trends ? (
					<div>
						{trends.legend.map((legend, index) => (
							<p key={index}>{legend}</p>
						))}
					</div>
				) : null}
			</div>
			<div className="uk-width-1-2@s">
				{checkboxes.map((checkbox, index) => (
					<label
						key={`${checkbox.text.split(' ').join('')}_${index}`}
						className={`reduced-size-label clickable_pointer`}
					>
						<input
							type="checkbox"
							onChange={(e) => {
								checkbox.onChange(e.target.checked);
							}}
							checked={checkbox.checked}
						/>
						{checkbox.text}
					</label>
				))}
			</div>
		</div>
	);
}
